import { ILayer, IMapContainer } from "../../map/types";
import { Checkbox } from "../checkbox";
import { useForceUpdate } from "../hooks";

interface LayerProps {
    map: IMapContainer;
    layer: ILayer;
    onUpdate?: () => void;
}

export function Layer({ layer, map, onUpdate }: LayerProps) {
    const refresh = useForceUpdate();

    const notify = React.useCallback(() => {
        // Call the external event handler.
        map.onVisibilityChanged(layer);

        // Force Angular to notice any changes made by React.
        map.$apply();
        // Force React to re-render to incorporate any changes made by Angular in response.
        onUpdate?.();
        refresh();
    }, [refresh, onUpdate, map, layer]);

    const toggleLabels = () => {
        layer.showLabels = !layer.showLabels;
        notify();
    };

    const setVisibility = (visible: boolean) => {
        layer.visible = visible;
        notify();
    };

    const labels = layer.showLabels
        ? { className: "show-labels", title: "Hide labels" }
        : { className: "show-labels hide-labels", title: "Show labels" };

    return (
        <div className="flex-row spc-0">
            <Checkbox
                cssClass="layer"
                disabled={layer.alwaysVisible === true}
                checked={layer.visible}
                setChecked={setVisibility}
            >
                {layer.description}
            </Checkbox>

            {layer.visible && (
                <div className={labels.className} style={{ margin: "0 5px" }}>
                    <button
                        type="button"
                        className="btn btn-link btn-floating-action small"
                        title={labels.title}
                        onClick={toggleLabels}
                    >
                        <span>A</span>
                    </button>
                </div>
            )}
        </div>
    );
}
